import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';

interface Guide {
  title: string;
  url: string;
  keywords: string[];
}

const GUIDES: Guide[] = [
  { title: 'Best Headphones', url: '/guides/best-headphones/', keywords: ['headphones', 'earbuds', 'audio', 'airpods'] },
  { title: 'Best Printers', url: '/guides/best-printers/', keywords: ['printer', 'scanner', 'ink'] },
  { title: 'Best Protein Powder', url: '/guides/best-protein-powder/', keywords: ['protein', 'whey', 'gym', 'fitness'] },
  { title: 'Best Air Purifiers', url: '/guides/best-air-purifiers/', keywords: ['air purifier', 'hepa', 'allergies'] },
  { title: 'Best 75-Inch TVs', url: '/guides/best-75-inch-tvs/', keywords: ['tv', 'oled', 'qled', '4k', 'television'] },
  { title: 'Best Robot Vacuums', url: '/guides/best-robot-vacuums/', keywords: ['robot vacuum', 'roomba'] },
  { title: 'Best Gaming Laptops', url: '/guides/best-gaming-laptops/', keywords: ['gaming laptop', 'gpu', 'rtx'] },
  { title: 'Best Gaming Headsets', url: '/guides/best-gaming-headsets/', keywords: ['gaming headset', 'esports'] },
  { title: 'Best Running Shoes', url: '/guides/best-running-shoes/', keywords: ['running shoes', 'marathon'] },
  { title: 'Best Treadmills', url: '/guides/best-treadmills/', keywords: ['treadmill', 'home gym', 'cardio'] },
  { title: 'Best Prenatal Vitamins', url: '/guides/best-prenatal-vitamins/', keywords: ['prenatal', 'vitamins', 'pregnancy'] },
  { title: 'Best Camera Phones', url: '/guides/best-camera-phones/', keywords: ['phone', 'smartphone', 'iphone', 'samsung', 'pixel'] },
];

interface RelatedGuidesProps {
  articleTitle: string;
  categoryName: string;
  tags: string[];
}

const RelatedGuides: React.FC<RelatedGuidesProps> = ({ articleTitle, categoryName, tags }) => {
  const matchedGuides = useMemo(() => {
    const searchText = `${articleTitle} ${categoryName} ${tags.join(' ')}`.toLowerCase();
    const matches = GUIDES.filter(guide =>
      guide.keywords.some(keyword => searchText.includes(keyword))
    );
    return matches.slice(0, 3);
  }, [articleTitle, categoryName, tags]);

  if (matchedGuides.length === 0) return null;

  return (
    <div className="max-w-3xl mx-auto px-4 py-8">
      <div className="border-t border-slate-200 pt-8">
        <h3 className="text-lg font-semibold text-slate-900 mb-4">Related Guides</h3>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {matchedGuides.map((guide) => (
            <Link
              key={guide.url}
              to={guide.url}
              className="block p-4 rounded-lg border border-slate-200 hover:border-blue-300 hover:shadow-sm transition-all"
            >
              <span className="text-sm font-medium text-blue-600 hover:text-blue-700">
                {guide.title} &rarr;
              </span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RelatedGuides;
